/**
 * i18n Configuration
 * Initializes i18next with bundled English locale resources.
 * @packageDocumentation
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import pagesEn from './locales/en/pages.json';
import commonEn from './locales/en/common.json';
import errorsEn from './locales/en/errors.json';

const NAMESPACES = ['common', 'pages', 'errors'] as const;

void i18n.use(initReactI18next).init({
  lng: 'en',
  fallbackLng: 'en',
  defaultNS: 'common',
  ns: [...NAMESPACES],
  interpolation: {
    escapeValue: false,
  },
  resources: {
    en: {
      pages: pagesEn,
      common: commonEn,
      errors: errorsEn,
    },
  },
  ...(import.meta.env.DEV && {
    saveMissing: true,
    missingKeyHandler: (_lngs: readonly string[], ns: string, key: string) => {
      console.warn(`[i18n] Missing key: ${ns}:${key}`);
    },
  }),
});

export default i18n;
